import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import type Gender from 'modules/settings/store/models/Gender'

class SchemaForm extends Form {
  constructor(values: object) {
    super(values, {
      name: 'string',
    })
  }
}

interface Props {
  gender: Gender | null | undefined
  onClose: () => void
}

const DeleteModal = ({ gender, onClose }: Props) => {
  if (!gender) return null

  const onSubmit = async (closePortal: ClosePortalFn) => {
    const { success } = await asyncAction(async () => {
      await gender.destroy()
    })

    if (success) closePortal()
  }

  return (
    <Modal
      illustration="delete"
      title={i18n.t('gender_settings.delete.title')}
      description={i18n.t('gender_settings.delete.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('gender_settings.delete.cancel')}
          </Button>
          <Button submit>{i18n.t('gender_settings.delete.accept')}</Button>
        </>
      }
    />
  )
}

export default DeleteModal
